export default __webpack_public_path__ + "static/media/globe-grid.69fd69ba.svg";